import React, { useEffect, useState } from "react";
// @ts-ignore
import Chart from "react-apexcharts";
// @ts-ignore
import { ApexOptions } from "apexcharts";

// @ts-ignore
import styles from "./PayGapBarChart.module.scss";
import Legend from "components/PayEquity/Legend";

const PayGapBarChart = ({ title, description, data, lables }: any) => {
  const [gap, setGap] = useState<any>(null);
  const [legendData, setLegendData] = useState<any>([]);
  const [barChartOptions, setBarChartOptions] = useState<ApexOptions>({
    chart: {
      width: 200,
      type: "bar",
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        distributed: true,
        barHeight: "70%"
      }
    },
    colors: ["#FFC759", "#00C29B"],
    stroke: {
      colors: ["#fff"],
      width: 0
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      categories: ["Female", "Male"]
    },
    yaxis: {
      show: false
    },
    legend: {
      show: false,
      position: "bottom",
      fontSize: "16px",
      fontWeight: 400,
      markers: {
        size: 16, // to be checked
        // width: 16,
        // height: 16,
        // radius: 5
      },
      itemMargin: {
        horizontal: 10
      },
      height: 50
    },
    grid: {
      show: false,
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: false
        }
      }
    },
    series: [
      { name: "", data: [] },
      { name: "", data: [] }
    ]
  });

  useEffect(() => {
    if (data && data.length) {
      const female = data[0] || 0;
      const male = data[1] || 0;
      let _gap = 0;

      if (male >= female) {
        _gap = male - female;
        _gap = +_gap.toFixed(2);
        setBarChartOptions({
          ...barChartOptions,
          series: [
            { name: "", data: [female, 0] },
            { name: "", data: [_gap, male] }
          ]
        });
      } else {
        _gap = female - male;
        _gap = +_gap.toFixed(2);
        setBarChartOptions({
          ...barChartOptions,
          series: [
            { name: "", data: [female, _gap] },
            { name: "", data: [0, male] }
          ]
        });
      }
      setGap(_gap);
      setLegendData([
        {
          name: (
            <>
              Female <strong>{female}%</strong>
            </>
          ),
          color: "#FFC759"
        },
        {
          name: (
            <>
              Male <strong>{male}%</strong>
            </>
          ),
          color: "#00C29B"
        }
      ]);
    }
  }, [data]);

  return (
    <>
      <div className={styles.chartWrapper}>
        <div className={styles.chartTitle}>{title}</div>
        <div className={styles.chartSubTitle}>Gap {gap}%</div>
        <Chart
          options={barChartOptions}
          series={barChartOptions.series}
          type="bar"
          width={200}
          height={250}
        />
        <Legend data={legendData} title="" className="" />
        <div className={styles.chartDescription}>{description}</div>
      </div>
    </>
  );
};

export default PayGapBarChart;
